var exports = {
  "LM": "diff-file-header__CV6GPS",
  "yZ": "collapsed__6txiiR",
  "vn": "file-name__8GKEHg",
  "O$": "file-name-truncate__1IBLuh",
  "PC": "file-path-section__ZYYNNI",
  "Gt": "hide-on-mobile__MZF-2t",
  "tj": "hide-on-small__kkglR4",
};

module.exports = exports;
